import meshRestrictionController from "../../../features/meshRestriction/meshRestrictionController"

const MenuHelper = {
    saveMenuItem(itemData) {
        if (isNullOrUndefined(itemData)) {
            return;
        }

        let result = [];
        itemData.forEach(menuItem => {
            result.push({
                name: menuItem.name,
                value: mController.getCurrentValue(menuItem.name)
            });
        });
        return result;
    },

    updateMenuItem(itemData) {
        if (isNullOrUndefined(itemData)) {
            return;
        }

        itemData.forEach(menuItem => {
            mController.updateMenuItemAction(menuItem.name, menuItem.value);
        });
    },

    enableRestriction(restrictionArray) {
        if (isNullOrUndefined(restrictionArray)) {
            return;
        }

        if (restrictionArray) {
            restrictionArray.forEach(restrictedObject => {
                restrictedObject.feature.forEach(feature => {
                    meshRestrictionController.updateRules(feature, restrictedObject.rules, restrictedObject.applyTo);
                });
            });
        }
    },

    removeRestriction(restrictionArray) {
        if (restrictionArray) {
            restrictionArray.forEach(restrictedObject => {
                restrictedObject.feature.forEach(feature => {
                    meshRestrictionController.clear(feature);
                });
            });
        }
    }
};

export default MenuHelper;